import { Component, OnInit, ViewChild } from '@angular/core';
import { fileObj, Product } from '../shared/misc-classes';
import { DataService } from '../shared/dataservice.service';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { FileUploader } from 'ng2-file-upload';

@Component({
  selector: 'app-drawing-uploader',
  templateUrl: './drawing-uploader.component.html',
  styleUrls: ['./drawing-uploader.component.css']
})
export class DrawingUploaderComponent implements OnInit {
  @ViewChild(FileUploadComponent) fileUploadComponent: FileUploadComponent;
  
  public uploader: FileUploader = new FileUploader({ url: '/uploadDrawfile' });

  _uploadDrawFolderList:Array<Product> = [];
  _uploadSOFolderList:any = [];

  selDrawFolder:string = "";
  saleOrderFolder:string = "";
  saleOrderNewFolder:string = "";
  SoFolder:string="";
  drawSubFolder:string="";
  fileList:Array<fileObj>=[];
  search: string='';
  isLoading: boolean = false;
  filteredSaleOrderArray: Array<string> = [];


  constructor(private _dataService: DataService) { }

  ngOnInit() {
    this._uploadDrawFolderList = this._dataService.uploadDrawFolderList;
    
  }

  ProductSelected(){
    this._dataService.getDrawFolderInfo(this.selDrawFolder).subscribe((resp) => {
       this._uploadSOFolderList = resp;
      // this._uploadFolderList = this._dataService.uploadFolderList;
      this.filterRows();
      });
   
    

    // console.log(this.selDrawFolder);
    // console.log("this._uploadFolderList::",this._uploadFolderList);
    
    // this.fileUploadComponent.updateDraw(this.selRTCFolder,this.saleOrderFolder, this.uploader);
  }
  DrawFolderSelected(){
    // console.log(this.selRTCFolder);
    // this._dataService.getDrawFolderInfo(this.selRTCFolder).subscribe((resp) => {
    //  this._uploadFolderList = resp;
    
    // });
  if(this.saleOrderFolder!=='new') {
    this.SoFolder = this.saleOrderFolder;
    this._dataService.getDrawFilesInfo(this.selDrawFolder,this.saleOrderFolder).subscribe((resp) => {
      this.fileList = resp;
      // this._uploadSOFolderList = resp;
     // this._uploadFolderList = this._dataService.uploadFolderList;
     });
    // this.fileUploadFunc(this.selRTCFolder,this.saleOrderFolder);
  }
  else this.SoFolder ="";

    // this.fileUploadComponent.updateDraw(this.selRTCFolder,this.saleOrderFolder, this.uploader);
  }
  DrawNewFolderSelected(_event){
    var newfoldr = _event.target.value;  
    this.saleOrderNewFolder = newfoldr.trim();
    if(this.saleOrderNewFolder.length==10){
      this.SoFolder = this.saleOrderNewFolder;
      // this.fileUploadFunc(this.selRTCFolder,this.saleOrderNewFolder);
    }
    else this.SoFolder="";
   
    // this.fileUploadComponent.updateDraw(this.selRTCFolder,this.saleOrderNewFolder, this.uploader);
  }
  DrawSubFolderSelected(){
    // // var newfoldr = _event.target.value;  
    // this.saleOrderNewFolder = newfoldr.trim();
    // if(this.saleOrderNewFolder.length>=10){
    //   this.SoFolder = this.saleOrderNewFolder;
    //   this.fileUploadFunc(this.selRTCFolder,this.saleOrderNewFolder);
    // }
    // else this.SoFolder="";
       // var newfoldr = _event.target.value;  
    if(this.drawSubFolder!=""){
      this.fileUploadFunc(this.selDrawFolder,this.SoFolder,this.drawSubFolder);
    }
    else this.drawSubFolder="";
    this.search = ''; // reset the search
    this.filterRows();

    // this.fileUploadComponent.updateDraw(this.selRTCFolder,this.saleOrderNewFolder, this.uploader);
  }
  fileUploadFunc(_folder1: string, _folder2: string, _folder3: string) {

    this.fileUploadComponent.updateDraw(_folder1, _folder2, _folder3, this.uploader);

  }

  prodSelected(_evnt){
    console.log(_evnt);
  }

  private _searchKeyTimer:any;
  searchInputChanged(){
    if(this._searchKeyTimer){
      clearTimeout(this._searchKeyTimer);
    }
    this._searchKeyTimer = setTimeout(() => {
      this.filterRows();
    }, (this.search.length < 5 ? 700 : 500));
  }
  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();  
      this.isLoading = false;
    }, 5);
  }
  filterRowsLogic2() {
    let _tmpSaleOrderArray: Array<string> = [];

    for (var i = 0; i < this._uploadSOFolderList.length; i++) {
      let _tmpSO = this._uploadSOFolderList[i];  
      let _isSOPassedFilter:boolean = this.isSaleOrderTestPassed(_tmpSO);
      if(_isSOPassedFilter == true){
        _tmpSaleOrderArray.push(_tmpSO);
    }
  }
  this.filteredSaleOrderArray = _tmpSaleOrderArray;

}
  private isSaleOrderTestPassed(_so:string):boolean{

    //check sono and customer name in search
    if(this.isSearchPassed(_so, this.search) == false) return false;

      return true;
    }
  
  private isSearchPassed(_soNo: string, _srchText: string): boolean {

    if (_srchText != '') {
      _srchText = _srchText.toLowerCase();
      if (_soNo && (_soNo + '').toLowerCase().indexOf(_srchText) >= 0) {
        return true;
      }
      return false;
    }

    return true;
  }
}

